<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                type="InertiaLink"
                :pages="[
                    {
                        name: $tc('messages.groups', 2),
                        href: meta.links.group_index,
                    },
                    {
                        name: group.name,
                        href: meta.links.group_show,
                    },
                    {
                        name: $tc('messages.grades', 2),
                        href: null,
                    },
                ]"
            />
        </template>

        <div class="flex space-x-2 items-center">
            <NavLinks :links="meta.navLinks" />
        </div>

        <div>
            <apexchart
                :type="averageGradeChartData.chart.type"
                :height="averageGradeChartData.chart.height"
                :series="averageGradeChartData.series"
                :options="averageGradeChartData"
            />
        </div>

        <div class="flex flex-wrap gap-2">
            <AppButton v-for="category in categories" :key="category.id" :href="category.url">
                {{ category.name }}
            </AppButton>
        </div>

        <div>
            <GradesBarGraphSortable
                :input-series="averageStudentGrade.chartDataOptions.series"
                :input-options="averageStudentGrade.chartDataOptions"
            />

            <div v-if="averageStudentGrade.scoresCount" class="flex space-x-2 flex-wrap">
                <span
                    class="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium {{ annotation['bg-color'] }} {{ $annotation['text-color'] }}"
                    :class="[annotation['bg-color'], annotation['text-color']]"
                    v-for="annotation in averageStudentGrade.annotations"
                    :key="annotation.id"
                >
                    {{ annotation.key }}: {{ annotation.value }}
                </span>
            </div>
        </div>

        <div class="mt-5 flex flex-wrap gap-2">
            <AppButton
                element="InertiaLink"
                v-for="student in meta.links.students"
                :href="student.url"
                :key="student.url"
            >
                {{ student.text }}
            </AppButton>
        </div>
    </PanelPage>
</template>

<script>
import Layout from '@/Shared/Layout.vue';
import PanelPage from '@/Shared/PanelPage.vue';
import AppButton from '@/components/AppButton.vue';
import GradesBarGraphSortable from '@/components/pageSpecific/GradesBarGraphSortable.vue';
import NavLinks from '@/components/NavLinks.vue';

export default {
    components: {
        PanelPage,
        AppButton,
        NavLinks,
        GradesBarGraphSortable,
    },
    layout: Layout,
    name: 'Show',
    props: ['averageGradeChartData', 'meta', 'group', 'categories', 'averageStudentGrade'],
};
</script>
